import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Footer.css";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    setMessage("");

    // Replace with your actual API key and list ID.
    const BREVO_API_KEY = "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";
    const BREVO_LIST_ID = 3;

    try {
      const response = await fetch("https://api.brevo.com/v3/contacts", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "api-key": BREVO_API_KEY,
        },
        body: JSON.stringify({
          email: email,
          listIds: [BREVO_LIST_ID],
        }),
      });

      const data = await response.json();
      if (response.ok) {
        setMessage("Subscription successful!");
        setEmail("");
        setShowPopup(true);
        setIsSubscribed(true);
      } else {
        setMessage("Subscription failed: " + (data.message || JSON.stringify(data)));
      }
    } catch (error) {
      setMessage("Error: " + error.message);
    }
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <>
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup">
            <p>Thank you for subscribing!</p>
            <button onClick={closePopup}>Close</button>
          </div>
        </div>
      )}

      {/* Newsletter Section */}
      <div className="newsletter-container">
        <div className="newsletter-content">
          <h2>Subscribe Newsletter</h2>
          <p>Stay Ahead of the Curve!</p>
          <p>
            Get the latest insights on technology, innovations, and our flagship
            products delivered straight to you.
          </p>
          <form className="subscribe-form" onSubmit={handleSubscribe}>
            <input
              type="email"
              placeholder="Your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button
              type="submit"
              className={`subscribe-btn ${isSubscribed ? "subscribe-btn-success" : ""}`}
            >
              Subscribe
            </button>
          </form>
          {message && <p>{message}</p>}
        </div>
        <div className="mailbox-icon">
          <img src={require("../assets/mailbox.png")} alt="Mailbox" />
        </div>
      </div>

      {/* Main Footer Content */}
      <footer className="footer">
        <div className="footer-content">
          {/* Company Info Section */}
          <div className="footer-section">
            <h2 className="company-name">EncryptArx</h2>
            <p className="company-description">
              ECX is a dynamic technology firm specializing in comprehensive
              cybersecurity solutions and cutting-edge product development. We
              offer penetration testing, infrastructure hardening, and bespoke
              software development to secure and empower digital ecosystems.
            </p>
            <div className="contact-info">
              <p>
                <span>📧</span> contact@encryptarx.in
              </p>
              <p>
                <span>📱</span> +91 6001563923
              </p>
              <p>
                <span>📍</span> Cuttack, Odisha, India <br /> Pin: 753002
              </p>
            </div>
          </div>

          {/* Company Links Section */}
          <div className="footer-section">
            <h3>Company</h3>
            <ul>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/">Careers</Link>
              </li>
              <li>
                <Link to="/">Terms & Conditions</Link>
              </li>
              <li>
                <Link to="/">Cookie Policy</Link>
              </li>
              <li>
                <Link to="/">Compliance</Link>
              </li>
              <li>
                <Link to="/TeamSection">Our Team</Link>
              </li>
            </ul>
          </div>

          {/* Features Links Section */}
          <div className="footer-section">
            <h3>Features</h3>
            <ul>
              <li>
                <Link to="/VAPT">Cybersecurity</Link>
              </li>
              <li>
                <Link to="/CAD">Secure Development</Link>
              </li>
              <li>
                <Link to="/AIAndMLConsulting">AI & ML Consultancy</Link>
              </li>
              <li>
                <Link to="/TechStackAsAService">Tech Stack as a Service</Link>
              </li>
              <li>
                <Link to="/TechAdvisoryConsulting">IT Consulting</Link>
              </li>
              <li>
                <Link to="/BlockchainDevelopmentServices">Blockchain</Link>
              </li>
            </ul>
          </div>

          {/* Our Works Links Section */}
          <div className="footer-section">
            <h3>Our Works</h3>
            <ul>
              <li>
                <Link to="/services">Our Services</Link>
              </li>
              <li>
                <Link to="/products">Our Products</Link>
              </li>
              <li>
                <Link to="/resources">Resources</Link>
              </li>
              <li>
                <Link to="/">Testimonials</Link>
              </li>
              <li>
                <Link to="/">Our Partners</Link>
              </li>
            </ul>
          </div>

          {/* Help Center Links Section */}
          <div className="footer-section">
            <h3>Help Center</h3>
            <ul>
              <li>
                <Link to="/contact">Support</Link>
              </li>
              <li>
                <Link to="/">FAQs</Link>
              </li>
              <li>
                <Link to="/">Privacy & Security Policies</Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Social Media Section */}
        <div className="social-section">
          <p>Follow us for more Updates</p>
          <div className="social-icons">
            <a
              href="https://www.instagram.com/encryptarx/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="2" y="2" width="20" height="20" rx="5" />
                <circle cx="12" cy="12" r="4" />
                <circle cx="17" cy="7" r="1" />
              </svg>
            </a>
            <a
              href="https://www.linkedin.com/company/encryptarx"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                <rect x="2" y="9" width="4" height="12" />
                <circle cx="4" cy="4" r="2" />
              </svg>
            </a>
            <a
              href="https://x.com/encryptarxx"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
            >
              <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z" />
              </svg>
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="copyright">
          <p>
            Copyrights © 2025 by <span className="highlight">EncryptArx</span>. All Rights Reserved || Design and Developed by{" "}
            <span className="highlight">ECX</span>
          </p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
